import { ICityInfo } from "common/interface/ICityInfo";

export const buildSocietyAmendmentPayload = (
  formData: Record<string, unknown>,
  cities: ICityInfo[],
  societyId?: string
): Record<string, unknown> => {
  const city = cities.find((e) => e.id === formData.cityId);
  const payload: Record<string, unknown> = { ...formData };

  payload.city = city?.name;
  payload.state = city?.state;

  const metadata = payload.metadata as Record<string, unknown> | undefined;
  if (metadata?.validSlots && Array.isArray(metadata.validSlots)) {
    metadata.validSlots = (metadata.validSlots as unknown[]).filter((slot) => slot != null);
  }

  if (societyId) {
    payload.id = societyId;
    payload.tower = ((payload.tower as unknown[]) ?? []).map((tower: unknown, index: number) => ({
      ...(tower as Record<string, unknown>),
      deliverySequence: index + 1,
    }));
    payload.verified = payload.verified ? 1 : 0;
  } else {
    payload.active = 1;
    payload.verified = 1;
    payload.tower = payload.tower ?? [];
  }

  return payload;
};

export const getApiErrorDetails = (error: unknown): { message: string; code?: string } => {
  const err = error as { response?: { data?: { message?: string; errors?: { code?: string; message?: string }[] } } };
  const data = err?.response?.data;
  const code = data?.errors?.[0]?.code;
  const message = data?.message || data?.errors?.[0]?.message || "Something went wrong!";
  return { message, code };
};
